module.exports = __webpack_public_path__ + "static/media/chu-mobile@2x.c421faf3.jpg";